export default {
  acab: 'ACAB',
  actions: '行动',
  addProduct: '添加產品',
  arcPosition: 'ARC 位置',
  businessId: '商業編號',
  businessPhone: '公司電話',
  cancel: '取消',
  client: '客戶',
  clientReference: '客戶參考',
  clients: '客户',
  clientSuccessfullyCreated: '客戶端成功創建',
  clv: 'CLV',
  codeLab: '代碼實驗室',
  colimptexCode: 'Colimptex 代碼',
  color: '顏色',
  colors: '色彩',
  colorSuccessfullyCreated: '顏色創建成功',
  colorSuccessfullyUpdated: '顏色已成功更新',
  composition: '組成',
  contactPerson: '聯繫',
  container: '容器',
  containers: '貨櫃',
  containerSuccessfullyCreated: '容器創建成功',
  containerSuccessfullyUpdated: '容器已成功更新',
  createClient: '创建客户端',
  createColor: '创建颜色',
  createContainerType: '创建容器类型',
  createOrderDetail: '创建订单详细信息',
  createOrder: '创建订单',
  createProduct: '创建产品',
  createPurchase: '创建购买',
  createPurchaseDetail: '创建购买详细信息',
  createSeller: '创建卖家',
  createSupplier: '创建供应商',
  created: '已成功创建',
  crf: 'CRF',
  csf: 'CSF',
  currency: '貨幣',
  deleteClient: '删除客户端',
  deletePurchase: '刪除購買',
  doYouWantToDeleteThisClient: '您真的要刪除此客戶端嗎？',
  doYouWantToDeleteThisColor: '您真的要刪除此顏色嗎？',
  doYouWantToDeleteThisContainer: '您真的要刪除此容器嗎？',
  doYouWantToDeleteThisProduct: '您真的要刪除此產品嗎？',
  doYouWantToDeleteThisPurchase: '您真的要刪除此購買嗎？',
  doYouWantToDeleteThisSeller: '您確實要刪除此賣家嗎？',
  doYouWantToDeleteThisSupplier: '您真的要刪除該供應商嗎？',
  editAddedProduct: '編輯添加的產品',
  editClient: '编辑客户端',
  editColor: '编辑颜色',
  editContainer: '編輯容器',
  editOrderDetail: '编辑订单详细信息',
  editOrder: '编辑顺序',
  editProduct: '编辑产品',
  editProvider: '编辑提供程序',
  editPurchase: '修改購買',
  editSeller: '编辑卖家',
  editSupplier: '編輯供應商',
  email: '电子邮件',
  enterDescription: '輸入用戶說明',
  factory: '廠',
  fca: 'FCA',
  fiber: '纖維',
  finalKilogramsQuantity: '最終數量（千克）',
  finalMetersQuantity: '最終數量（以米為單位）',
  finished: '已完成',
  hs: 'HS',
  iva: 'IVA',
  key: '鍵',
  kilogramsMaximumCapacity: '最大容量（千克）',
  label: '標籤',
  language: '語言',
  loading: '加载。。。',
  metersKilogramsQuantity: 'm/kg 數量',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: '在创建项目之前必须收费',
  name: '名字',
  newClient: '新客户',
  newColor: '新颜色',
  newContainer: '',
  newOrderDetail: '新订单详细信息',
  newOrder: '新订单',
  newProduct: '新产品',
  newProvider: '新提供程序',
  newPurchase: '新購買',
  newSeller: '新卖家',
  newSupplier: '新供應商',
  nit: '身份證號碼',
  noElementsRegistered: '未注册任何元素',
  onlyNumbersAllowed: '只允許數字',
  paint: '塗料',
  performance: '性能',
  phone: '电话',
  portOccupation: '港口職業',
  print: '列印',
  productionDate: '生產日期',
  product: '產品',
  products: '產品展示',
  productSuccessfullyCreated: '產品成功創建',
  productSuccessfullyUpdated: '產品更新成功',
  profileImagePath: '個人資料圖片網址',
  psv: 'PSV',
  purchaseSuccessfullyCreated: '購買成功創建',
  purchaseSuccessfullyUpdated: '購買成功更新',
  pvp: 'PVP',
  referenceInChina: '中國參考',
  rgb: 'RGB',
  requiredAmount: '所需金額',
  requirement: '需求',
  save: '救',
  search: '搜索',
  seller: '賣方',
  sellers: '賣家',
  sellerSuccessfullyCreated: '賣家成功創建',
  sellerSuccessfullyUpdated: '賣家已成功更新',
  shippingDate: '發貨日期',
  shortName: '簡稱',
  sku: 'SKU',
  subInvoice: '子發票',
  sublimation: '昇華',
  supplier: '供應商',
  suppliers: '供應商',
  supplierSuccessfullyCreated: '供應商成功創建',
  supplierSuccessfullyUpdated: '供應商成功更新',
  taxesRefund: '退稅',
  totalAmount: '總金額',
  trm: 'TRM',
  typeOfContainer: '容器類型',
  updated: '已成功更新',
  unitMeasure: '測量單位',
  viewClient: '查看客户端',
  weight: '重量',
  wide: '寬',
  withholdingTax: '預扣稅'
}
